import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { StyledSection } from '../styles/elements'
import bgImage from '../static/images/backgrounds/index_bg.png'
import texture from '../static/images/backgrounds/logo_lines.png'
import logoSrc from '../static/images/general/logo.png'
import { colors, media } from '../styles/vars'
import Knobs from '../components/Knobs'
import { scroller } from 'react-scroll'

const infiniteMotion = keyframes`
0%{
    background-position:right 0 top 125px;
}
100%{
    background-position:right 2000px top 125px;
}
`

const Container = styled(StyledSection) `
min-height:80vh;
background-position:center top 100px;
background-color:${colors.black};
background-image:url(${bgImage});
${
    media.desktop`
    min-height:1000px;
    `
    }
`
const Content = styled.div`
padding:70px 0;
text-align:center;
background-image:url(${texture});
background-repeat:no-repeat;
background-repeat-x:repeat;
background-position:right top 125px;
animation:${infiniteMotion} 30s linear infinite;
`
const LogoContainer = styled.div`
max-width:80%;
display:inline-block;
margin:0 auto;
`
const IntroCaption = styled.h3`
color:${colors.black};
background-color:${colors.white};
font-weight:700;
padding: 5px 5px 2px;
display:inline-block;
font-size:2.4rem;
float:left;
transform:translate3d(0, 10px, 0);
`
const TextContainer = styled.div`
max-width:90%;
margin:10px auto;
`
const Text = styled.p`
font-weight:700;
font-size:3.5rem;
color:${colors.white};
span{
    color:${colors.purple};
}
label{
    color:${colors.lightblue};
}
label > label{
    display:inline-block;
    white-space:nowrap;
}
`
const SmallText = styled(Text) `
font-size:3.2rem
`
const CreditText = styled.p`
font-size:2.5rem;
color:${colors.white};
margin-top:10px;
`
const KnobsContainer = styled.div`
padding-top:12vh;

${
    media.desktop`
    padding-top:300px;
    `
    }
`

class IntroSection extends Component {
    constructor() {
        super();
        this.onKnobClick = this.onKnobClick.bind(this);
        this.state = {};
    }
    onKnobClick() {
        this.setState({
            knobActive: true
        });
        scroller.scrollTo("ampSection", {
            duration: 1000,
            smooth: true,
            offset: this.props.isMobile ? 80 : -370,
            delay: 50
        })
    }
    render() {
        return (
            <Container>
                <Content>
                    <LogoContainer>
                        <div>
                            <IntroCaption>פרויקט מיוחד</IntroCaption>
                        </div>
                        <div>
                            <img src={logoSrc} alt="טונים צורמים" />
                        </div>
                    </LogoContainer>
                    <TextContainer>
                        <Text>התקלה המופלאה שהביאה לעולם את הרוקנ'רול</Text>
                        <SmallText>
                            <span>דיסטורשן - </span>
                            <label>איך זה התחיל, איך זה עובד ואיך <label>זה נשמע?</label></label>
                        </SmallText>
                        <CreditText>
                            עורכים: עמי פרידמן ודרור עמיר
                        </CreditText>
                    </TextContainer>
                    <KnobsContainer>
                        <Knobs onKnobClick={this.onKnobClick} knobActive={this.state.knobActive} />
                    </KnobsContainer>
                </Content>
            </Container>
        );
    }
}

export default IntroSection;


// WEBPACK FOOTER //
// ./src/containers/IntroSection.jsx